export default __webpack_public_path__ + "static/media/wmlWebsite4.40779115.jpg";